class TimeSpan {
    private readonly totalSeconds: number;
    private readonly unitNames: string[][] = [["seconde", "seconden"], ["minuut", "minuten"], ["uur", "uur"]];

    constructor(timeString: string) {
        const timeParts = timeString.split(':');
        const seconds = parseInt(timeParts[2], 10);
        const minutes = parseInt(timeParts[1], 10);
        const hoursDays = timeParts[0].split('.');
        let hours: number;
        let days: number;

        if (hoursDays.length === 2) {
            days = parseInt(hoursDays[0], 10);
            hours = parseInt(hoursDays[1], 10);
        } else {
            days = 0;
            hours = parseInt(hoursDays[0], 10);
        }

        // Convert everything to seconds and store in totalSeconds
        this.totalSeconds = (((days * 24 + hours) * 60) + minutes) * 60 + seconds;
    }

    getHours() : number {
        return Math.floor(this.totalSeconds / 3600);
    }
    getMinutes() : number {
        return Math.floor((this.totalSeconds % 3600) / 60);
    }
    getSeconds() : number {
        return Math.floor(this.totalSeconds % 60);
    }

    getTotalHours(): number {
        return Math.floor(this.totalSeconds / 3600);
    }

    getTotalMinutes(): number {
        return Math.floor(this.totalSeconds / 60);
    }

    getTotalSeconds(): number {
        return this.totalSeconds;
    }

    toString() {
        let str : string[] = [];
        if (this.getHours() != 0)
            str.push(`${this.getHours()} ${this.unitNames[2][this.getHours() == 1 ? 0 : 1]}`);
        if (this.getMinutes() != 0)
            str.push(`${this.getMinutes()} ${this.unitNames[1][this.getMinutes() == 1 ? 0 : 1]}`);
        if (this.getSeconds() != 0)
            str.push(`${this.getSeconds()} ${this.unitNames[0][this.getSeconds() == 1 ? 0 : 1]}`);
        
        if (str.length == 0)
            return "0";

        return str.join(", ");
    }

    toStringShort() {
        let str : string[] = [];
        str.push(this.getHours().toString().padStart(2, '0'));
        str.push(this.getMinutes().toString().padStart(2, '0'));
        str.push(this.getSeconds().toString().padStart(2, '0'));

        return str.join(":");
    }
}